export default "__VITE_ASSET__CcO9oKwk__"